<div class="image-popup-container">
  <!-- Fixed Header -->
  <div class="popup-header">
    <div>
      <h4>{{ displayName | translate | async }}:</h4>
    </div>

    <div>
      <i
        class="material-icons __close-button"
        (click)="onNoClick()"
        matTooltip="Close Popup"
      >
        close
      </i>
    </div>
  </div>

  <!-- Scroll Area -->
  <div class="image-scroll-container">
    <div *ngIf="imagesHx?.length > 0; else NoData">
      <div *ngFor="let group of imagesHx">
        <div class="image-container">
          <!-- Inspection Details -->
          <div class="image-header">
            <div class="div-flex">
              <span class="image-text-label"
                >{{ "Date" | translate | async }}:</span
              >
              <span class="comment-label">
                <ng-container *ngIf="module == ModuleType.UC; else getDate">
                  {{ group.InspectionDate | date: "dd MMM yyyy" }}
                </ng-container>

                <ng-template #getDate>
                  {{ group.InspectionDate }}
                </ng-template>
              </span>
            </div>

            <div class="div-flex">
              <span class="image-text-label"
                >{{ "SMU" | translate | async }}:</span
              >
              <span class="comment-label">
                {{ group.SMU }}
              </span>
            </div>

            <div class="div-flex" *ngIf="group.Life != null">
              <span class="image-text-label"
                >{{ "Asset Hours" | translate | async }}:</span
              >
              <span class="comment-label">
                {{ group.Life }}
              </span>
            </div>

            <div class="div-flex" *ngIf="group.WornPct != null">
              <span class="image-text-label"
                >{{ "Worn" | translate | async }}%:</span
              >
              <span class="comment-label"> {{ group.WornPct }}% </span>
            </div>

            <!-- Crack Details -->
            <div *ngIf="group.CrackLength != null">
              <div class="div-flex">
                <span class="image-text-label"
                  >{{ "Crack Length" | translate | async }} ({{
                    group.UserUOM
                  }}):</span
                >
                <span class="comment-label">
                  {{ group.CrackLength }}
                </span>
              </div>

              <div class="div-flex">
                <span class="image-text-label"
                  >{{ "Crack Status" | translate | async }}:</span
                >
                <span class="comment-label">
                  {{ group.CrackStatus }}
                </span>
              </div>
            </div>
            <div class="div-flex" *ngIf="group.WornPct != null">
              <span class="image-text-label"
                >{{ "Comments" | translate | async }}:</span
              >
              <span class="comment-label">{{ group.Comments }}</span>
            </div>
          </div>

          <!-- Images -->
          <div>
            <img
              style="width: 180px"
              class="inspection-observation-photo"
              *ngFor="let img of group.Images"
              [src]="img.ImageDataPath"
              [alt]="'Inspection Image'"
              (click)="openImagePopUp(img.ImageDataPath)"
            />
          </div>
        </div>
      </div>
    </div>

    <ng-template #NoData>
      <div class="text-center">
        <h3>{{ "No data found" | translate | async }}!</h3>
      </div>
    </ng-template>
  </div>
</div>
